import React from "react"

import { isLTPM } from "../../../../../components/shared_components_registration"
import { stringifyDate } from "../../../../utils"

export const getStatusDetails = (labelingCompleteOn, labelingCompleteBy) => {
  const toggleDate = stringifyDate(labelingCompleteOn, true, false, false)
  return toggleDate && labelingCompleteBy
    ? `Current Status Set By ${labelingCompleteBy} On ${toggleDate}`
    : ""
}

export default function LabelingCompleteLabel({ run, customStyle = {} }) {
  const { labelingComplete, labelingCompleteBy, labelingCompleteOn } = run
  const eventLabelColor = `var(--lanzalake-${labelingComplete ? "green-primary" : "purple"})`
  return (
    <>
      {!isLTPM && (
        <>
          &nbsp;
          <span
            className="bordered"
            style={{
              ...customStyle,
              color: eventLabelColor,
              borderColor: eventLabelColor,
              cursor: "default",
            }}
            title={getStatusDetails(labelingCompleteOn, labelingCompleteBy)}
          >
            <span className={"fa fa-tag"} aria-hidden="true" style={{ color: eventLabelColor }} />
            &nbsp;
            {`${labelingComplete ? "C" : "Inc"}omplete`}
          </span>
        </>
      )}
    </>
  )
}
